//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'goSearch',
  props: {
    searchTips: {
      type: String,
      default: ''
    },
    searchLink: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
